import { ColumnViewModel } from '../../shared/column-types';

export const GENES_ALL: ColumnViewModel = {
  columns: [
    'symbol',
    'description',
    'ncbiID',
    'gene_ensembl_id',
    'proteinIDs',
    'proteinClassIDs',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'ncbi_type',
    'numCTs',
    'nct_id',
    'pathwayName',
    'pathwayID',
    'numChemicals',
    'DSI',
    'DPI',
    'PLI',
    'numPublications',
    'numberPmidsWithChemsIncludedInEvidence',
    'firstRef',
    'lastRef',
  ],
  defaultVisible: [
    'symbol',
    'description',
    'proteinClassIDs',
    'numDiseasesAssociatedToGene',
    'numVariantsAssociatedToGene',
    'numCTs',
    'DSI',
    'DPI',
    'PLI',
    'numPublications',
    'firstRef',
    'lastRef',
  ],
};